import { UNITS } from "../lib/constants";

export function UnitPills({ value, onChange, testid = "unit-pills" }) {
    return (
        <div className="inline-flex rounded-lg border border-brand-line bg-white p-1" data-testid={testid}>
            {UNITS.map((u) => (
                <button
                    key={u}
                    type="button"
                    data-testid={`unit-${u}`}
                    onClick={() => onChange(u)}
                    className={`px-3 py-1.5 text-xs font-semibold uppercase tracking-wider rounded-md transition ${
                        value === u
                            ? "bg-brand-navy text-white"
                            : "text-brand-ink/60 hover:text-brand-ink"
                    }`}
                >
                    {u}
                </button>
            ))}
        </div>
    );
}
